import Reveal from "@/components/base/Reveal";
import SectionHead from "@/components/base/SectionHead";
import { pollGuides } from "@/mocks/dailyContest";

export default function Poll() {
  return (
    <section id="poll" className="border-b border-background-300/70 bg-background-50 py-12 md:py-16">
      <div className="container-x">
        <Reveal>
          <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
            <SectionHead
              eyebrow="投票打榜 · 攻略"
              title="把票投在刀刃上的方法论"
              desc="每轮助力规则上线都会同步整理，覆盖账号权重、黄金时段、双平台打通与理性集资，附真实数据复盘。"
            />
            <div className="flex items-center gap-2 text-sm text-foreground-500">
              <i className="ri-lightbulb-flash-line text-accent-500" aria-hidden="true" />
              已更新至最新赛制 · 240 期攻略
            </div>
          </div>
        </Reveal>

        <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {pollGuides.map((g, i) => (
            <Reveal key={g.id} delay={i * 60}>
              <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-300/70 bg-background-100 transition-colors hover:border-primary-300">
                <div className="relative h-40 overflow-hidden">
                  <img
                    src={g.img}
                    alt={`${g.title}配图`}
                    title={`每日大赛网 · ${g.title}`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="chip absolute left-3 top-3 bg-background-950/75 text-background-100">
                    <i className="ri-thumb-up-fill mr-1" aria-hidden="true" />
                    {g.tag}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-4 md:p-5">
                  <a
                    href="#gossip"
                    className="cursor-pointer font-serif text-[17px] font-bold leading-6 text-foreground-950 transition-colors group-hover:text-primary-700"
                  >
                    {g.title}
                  </a>
                  <p className="mt-2 line-clamp-3 flex-1 text-[13px] leading-6 text-foreground-600">{g.lead}</p>
                  <div className="mt-4 flex items-center justify-between border-t border-background-300/60 pt-3">
                    <span className="text-xs font-medium text-foreground-500">{g.time}</span>
                    <span className="flex h-8 w-8 items-center justify-center rounded-full border border-background-300 text-foreground-600 transition-colors group-hover:border-primary-400 group-hover:bg-primary-600 group-hover:text-background-50">
                      <i className="ri-arrow-right-line text-sm" aria-hidden="true" />
                    </span>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={140}>
          <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-lg border border-dashed border-secondary-300 bg-secondary-50 px-6 py-5 sm:flex-row">
            <div className="flex items-center gap-3">
              <i className="ri-notification-3-line text-xl text-secondary-700" aria-hidden="true" />
              <p className="text-sm text-foreground-700">
                规则一变就打榜，别再走弯路 —— 追最新攻略前先看看
                <a href="#faq" className="mx-1 font-bold text-primary-600 hover:text-primary-700">打榜常见问题</a>
                。
              </p>
            </div>
            <a
              href="#faq"
              className="inline-flex shrink-0 cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-secondary-600 px-4 py-2 text-[13px] font-bold text-background-50 transition-colors hover:bg-secondary-700"
            >
              看常见问题
              <i className="ri-question-line" aria-hidden="true" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}